<div id="alert" [ngClass]="{'has-descriptive': service?.rbacManagement('vehicles_DescriptiveAnalysis'),'-tab-landing': !service.rbacManagement('entities_DateTimeRangeFilter')}"
  class="-mat-select-height-unset -border-bottom-none">
  <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedTabIndex" class="-sticky-header">
    <mat-tab label="{{tab.label}}" *ngFor="let tab of profileTabList|commonSearch:'isActive':'tabList';let i = index"
      class="tab-landing-attributes">
      <div [ngSwitch]="tab.id">
        <!-- dover start-->
        <div *ngSwitchCase="'vitalsHistory'">
          <app-generic-filter [tabData]="tabData" (genericFilter)="onGenericFilterChange($event)"
            *ngIf="i===selectedTabIndex">
          </app-generic-filter>
          <app-dover-vitals-history *ngIf="i===selectedTabIndex" [genericFilter]="genericFilterData"
            [tabData]="{entityId: tabData?._id}">
          </app-dover-vitals-history>
        </div>
        <!-- dover end-->
        <!-- attributes chart start -->
        <div *ngSwitchCase="'attributesChart'">
          <app-attributes-charts *ngIf="i===selectedTabIndex" [entityData]="tabData"
            [attributeType]="tab?.attributeType">
          </app-attributes-charts>
        </div>
        <!-- attributes chart end -->
        <!-- cnp start-->
        <div *ngSwitchCase="'monotainerHistory'">
          <app-generic-filter [tabData]="tabData" (genericFilter)="onGenericFilterChange($event)" [exportNeeded]="false"
            *ngIf="i===selectedTabIndex">
          </app-generic-filter>
          <app-monotainer-history *ngIf="i===selectedTabIndex" [tabData]="{entityId: tabData?._id}"
            [refreshRate]="refreshRate" [genericFilter]="genericFilterData">
          </app-monotainer-history>
        </div>
        <!-- cnp end-->
        <!-- rul statistics start-->
        <div *ngSwitchCase="'rulStatistics'">
          <app-rul-statistics *ngIf="i===selectedTabIndex" [entityData]="tabData"></app-rul-statistics>
        </div>
        <!-- rul statistics end -->
        <!-- telematics histroy start-->
        <div *ngSwitchCase="'telematicsHistory'">
          <app-telematics-histroy *ngIf="i===selectedTabIndex" [entityData]="tabData">
          </app-telematics-histroy>
        </div>
        <!-- telematics histroy end-->
        <!-- alerts start -->
        <div *ngSwitchCase="'alerts'">
          <app-entity-alerts *ngIf="i===selectedTabIndex" [entityId]="tabData?._id"></app-entity-alerts>
        </div>
        <!-- alerts end -->
        <!-- vechile stats start -->
        <div *ngSwitchCase="'vehicleStatistics'">
          <app-vehicle-statistics *ngIf="i===selectedTabIndex" [entityData]="tabData">
          </app-vehicle-statistics>
        </div>
        <!-- vechile stats end -->
        <!-- history playBack start -->
        <div *ngSwitchCase="'historyPlayBack'">
          <app-history-playback *ngIf="i===selectedTabIndex" [entityData]="tabData">
          </app-history-playback>
        </div>
        <!-- history playBack end -->
        <!-- insights start -->
        <div *ngSwitchCase="'insights'">
          <app-insights *ngIf="i===selectedTabIndex" [entityId]="tabData?._id">
          </app-insights>
        </div>
        <!-- insights end -->
        <!-- Descriptive Analysis start -->
        <div *ngSwitchCase="'descriptiveAnalysis'">
          <app-descriptive-analysis *ngIf="i===selectedTabIndex" [entityData]="tabData">
          </app-descriptive-analysis>
        </div>
        <!-- Descriptive Analysis end -->
        <!-- Attributes ontology start -->
        <div *ngSwitchCase="'attributesOntology'">
          <app-attributes-ontology [entityData]="tabData" *ngIf="i===selectedTabIndex">
          </app-attributes-ontology>
        </div>
        <!-- Attributes ontology end -->
        <!-- Attributes health start -->
        <div *ngSwitchCase="'attributesHealth'">
          <app-peripherals [entityData]="tabData" *ngIf="i===selectedTabIndex && !osFlag"> </app-peripherals>
          <app-attributes-health [entityData]="tabData" *ngIf="i===selectedTabIndex && osFlag"></app-attributes-health>
        </div>
        <!-- Attributes health end -->
        <!-- Module health start -->
        <div *ngSwitchCase="'moduleHealth'">
          <app-module-health [entityData]="tabData" *ngIf="i===selectedTabIndex"></app-module-health>
        </div>
        <!-- Module health end -->
        <!-- App health start -->
        <div *ngSwitchCase="'appHealth'">
          <app-app-health [entityData]="tabData" *ngIf="i===selectedTabIndex"></app-app-health>
        </div>
        <div *ngSwitchCase="'packageHistory'">
          <app-package-history [entityData]="tabData"></app-package-history>
        </div>
        <!-- App health end -->
        <!--Telemetry Data starts-->
        <div *ngSwitchCase="'telemetryData'">
          <app-telemetry-data [entityData]="tabData" *ngIf="i===selectedTabIndex" [fromDate]="fromDate" [toDate]="toDate"></app-telemetry-data>
        </div>
        <!--Telemetry Datat ends-->
        <div *ngSwitchCase="'dtc'">
          <app-case-listing *ngIf="i===selectedTabIndex" [entityData]="tabData" [pageType]="'entityProfile'" [dtcType]="'dtc'"></app-case-listing>
        </div>
        <div *ngSwitchCase="'noDtc'">
          <app-case-listing *ngIf="i===selectedTabIndex" [entityData]="tabData" [pageType]="'entityProfile'" [dtcType]="'noDtc'"></app-case-listing>
        </div>
        <div *ngSwitchCase="'dtcTrails'">
          <app-dtc-trails *ngIf="i===selectedTabIndex" [entityData]="tabData">
          </app-dtc-trails>
        </div>
        <div *ngSwitchCase="'dtcPredictions'">
          <app-dtc-predictions *ngIf="i===selectedTabIndex" [entityData]="tabData">
        </app-dtc-predictions>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>